<template>
  <b-form-group
    label="Görüşme Durumu"
    label-for="title"
  >
    <validation-provider
      #default="{ errors }"
      name="Görüşme Durumu"
      rules="required"
    >
      <v-select
        v-model="dataItem.id_interview_statuses"
        :options="statuses"
        label="title"
        :reduce="item => item.id"
        placeholder="Seçiniz"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'InterviewStatus',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  props: {
    isLocked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['interviews/dataItem']
    },
    statuses() {
      return this.$store.getters['interviewStatuses/dataList']
    },
  },
  created() {
    this.getData()
    localize('tr')
  },
  methods: {
    getData() {
      const where = {}
      if (this.dataItem.id_interview_subjects) {
        where['interview_statuses.id_interview_subjects'] = this.dataItem.id_interview_subjects
      }
      this.$store.dispatch('interviewStatuses/getDataList', {
        select: [
          'interview_statuses.id AS id',
          'interview_statuses.title AS title',
        ],
        where,
      })
    },
  },
}
</script>
